import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_EMP_WORKING_PROJECTS,
  GET_EMP_WORKING_PROJECTS_SUCCESS,
  GET_EMP_TASK_SUCCESS,
  GET_EMP_TASK,
  GET_ALL_TASK_OF_PROJECT,
  GET_ALL_TASK_OF_PROJECT_SUCCESS,
  ADD_TASK,
  ADD_TASK_SUCCESS,
  UPDATE_TASK,
  UPDATE_TASK_SUCCESS,
  DEL_TASK,
  DEL_TASK_SUCCESS,
  ADD_TASK_UNLOCK_REQUEST_SUCCESS,
  ADD_TASK_UNLOCK_REQUEST,
  GET_TASK_UNLOCK_REQUEST,
  GET_TASK_UNLOCK_REQUEST_SUCCESS,
  GET_Leave_REQUEST_SUCCESS,
  GET_RECANDHOLIDAY_CALENDAR,
  GET_RECANDHOLIDAY_CALENDAR_SUCCESS,
  DELETE_APPLIED_LEAVES,
  DELETE_APPLIED_LEAVES_SUCCESS,
  UPDATE_STATUS_TASK,
  UPDATE_STATUS_TASK_SUCCESS,
} from "../redux/actions/actionType";
import api from "../apis/api";
import { tasks } from "../datas/tasks";

// Api Functions.
function* getEmployeeWorkingProjectsApi(employeeId) {
  // api call all task .
  // api call all projects of corresponding employee.
  const empWorkingProjects = yield api
    .project()
    .getProjectsOfEmployee(employeeId);

  let empTask = tasks.filter((el) => el.employeeId === employeeId);
  let projectNames = [];

  return { empTask, projectNames, empWorkingProjects: empWorkingProjects.data };
}

function* getEmployeeTaskApi(employeeId) {
  // api call.
  let projectIssueList = yield api.projectIssue().GetAllProjectIssueList();
  // console.log(projectIssueList.data);

  let response = yield api.task().getAllTaskOfEmployee(employeeId);
  // return projectIssueList.data;

  return response.data;
}

function* getTaskUnlockReqApi(payload) {
  let response = yield api.dailytask().getUnlockReq(payload);

  return response.data;
}
// function* getRecHolidayCalendarApi() {
//   // api for get employeetype
//   let response =yield api.dbcalendar().GetRecHolidayCalendarList();
//   return response.data;
// }
function* getLeaveReqApi(payload) {
  let response = yield api.dailytask().getLeaveReq(payload);

  return response.data;
}
function getAllTaskOfProjectsApi(projectId) {
  let projectTaskList = tasks.filter((el) => el.projectId === projectId).sort((a, b) =>
  a.projectName > b.projectName ? 1 : -1,
);

  return { projectTaskList };
}
function addTaskApi(formData, taskProjectId) {
  // api call to add task.
  const res =  api.dailytask().addEdit(formData);
  //console.log("res",res);
  return res;
}
function updateTaskstatusApi(formData) {
  // api call to add task.
  const res =  api.dailytask().UpdateTask(formData);
  //console.log("res",res);
  return formData;
}
function unlockRequestApi(formData) {
  // api call to add task.
  const res =  api.dailytask().unlockReq(formData);
  //console.log("res",res);
  return formData;
}

function updateTaskApi(formData, taskProjectId) {
  // api call to update task.
  const res =  api.dailytask().addEdit(formData);

  return formData;
}

function delTaskApi(delId) {
  //api call
  const res =  api.dailytask().deleteTask(delId);
  return delId;
}
function delAppliedLeavesApi(leaverequestId) {
  //api call
  const res =  api.dbCalendarYear().DeleteLeaveApply(leaverequestId);
  return leaverequestId;
}
// --------------------------------------------------------------------------------------
// get all the task of a particular employee.
// export function* handleGetRecHolidayCalendar() {
//   try {
//     const response = yield call(getRecHolidayCalendarApi);
//     console.log(response.data);
//     yield put({ type: GET_RECANDHOLIDAY_CALENDAR_SUCCESS, payload: response.data });
//   } catch (error) {
//      
//   }
// }
export function* handleGetEmployeeWorkingProjects(empId) {
  try {
    const { empTask, projectNames, empWorkingProjects } = yield call(
      getEmployeeWorkingProjectsApi,
      empId.payload
    );
    yield put({
      type: GET_EMP_WORKING_PROJECTS_SUCCESS,
      payload: { empTask, projectNames, empWorkingProjects },
    });
  } catch (error) {
     
  }
}
// get all tasks of a particular project.
export function* handleGetAllTaskOfProject({ payload }) {
  try {
    const projectId = payload;

    const { projectTaskList } = yield call(getAllTaskOfProjectsApi, projectId);

    yield put({
      type: GET_ALL_TASK_OF_PROJECT_SUCCESS,
      payload: projectTaskList,
    });
  } catch (error) {
     
  }
}

// add task
export function* handleAddTask({ payload }) {
  try {
 yield call(addTaskApi, payload.formData, payload.taskProjectId);
    yield put({
      type: ADD_TASK_SUCCESS,
      formData:payload.formData,
      taskProjectId: payload.taskProjectId,
    });
    let employeeId = payload;
    let response = yield call(getEmployeeTaskApi, payload.formData.employeeID);
    yield put({ type: GET_EMP_TASK_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
export function* handleupdateTaskstatus({ payload }) {
  try {
    yield call(updateTaskstatusApi, payload.formData);
    yield put({
      type: UPDATE_STATUS_TASK_SUCCESS,
      formData: payload.formData,
      
    });
    let employeeId = payload;
    let response = yield call(getEmployeeTaskApi, payload.formData.employeeID);
    yield put({ type: GET_EMP_TASK_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
export function* handleUnlockRequest({ payload }) {
  try {
    yield call(unlockRequestApi, payload);
    yield put({
      type: ADD_TASK_UNLOCK_REQUEST_SUCCESS,
      formData: payload,
      UnlockRequestId: payload.unlockRequestId,
    });
    // let response = yield call(getTaskUnlockReqApi, payload);
    // yield put({ type: GET_TASK_UNLOCK_REQUEST_SUCCESS, payload: response });
  } catch (error) {
     
  }
}

// update task
export function* handleUpdateTask({ payload }) {
  try {
    yield call(updateTaskApi, payload.formData, payload.taskId);
    yield put({
      type: UPDATE_TASK_SUCCESS,
      formData: payload.formData,
      taskId: payload.taskId,
    });
    let employeeId = payload;
    let response = yield call(getEmployeeTaskApi, payload.formData.employeeID);
    yield put({ type: GET_EMP_TASK_SUCCESS, payload: response });
  } catch (error) {
     
  }
}

//  delete task.
export function* handleDelTask(delId) {
  try {
    yield call(delTaskApi, delId.payload);
    yield put({ type: DEL_TASK_SUCCESS, payload: delId.payload });
  } catch (error) {
     
  }
}
export function* handleDelAppliedLeave(leaverequestId) {
  try {
    yield call(delAppliedLeavesApi, leaverequestId.payload);
    yield put({ type: DELETE_APPLIED_LEAVES_SUCCESS, payload: leaverequestId.payload });
  } catch (error) {
     
  }
}
// handle to get all tasks of a particular employee.
export function* handleGetEmployeeTask({ payload }) {
  try {
    let employeeId = payload;
    let response = yield call(getEmployeeTaskApi, employeeId);
    yield put({ type: GET_EMP_TASK_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
export function* handleGetTaskUnlockRequest({payload}) {
  try {
    let response = yield call(getTaskUnlockReqApi, payload);
    yield put({ type: GET_TASK_UNLOCK_REQUEST_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
export function* handleGetLeaveRequest({payload}) {
  try {
    let response = yield call(getLeaveReqApi, payload);
    yield put({ type: GET_Leave_REQUEST_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
// watch function.
export function* taskWatchFun() {
  yield takeLatest(GET_EMP_WORKING_PROJECTS, handleGetEmployeeWorkingProjects);
  yield takeLatest(ADD_TASK, handleAddTask);
  yield takeLatest(UPDATE_STATUS_TASK,handleupdateTaskstatus);
  yield takeLatest(UPDATE_TASK, handleUpdateTask);
  yield takeLatest(DEL_TASK, handleDelTask);
  yield takeLatest(GET_ALL_TASK_OF_PROJECT, handleGetAllTaskOfProject);
  yield takeLatest(GET_EMP_TASK, handleGetEmployeeTask);
  yield takeLatest(ADD_TASK_UNLOCK_REQUEST,handleUnlockRequest);
  yield takeLatest(GET_TASK_UNLOCK_REQUEST,handleGetTaskUnlockRequest);
  yield takeLatest(DELETE_APPLIED_LEAVES,handleDelAppliedLeave);
  // yield takeLatest(GET_RECANDHOLIDAY_CALENDAR, handleGetRecHolidayCalendar);
}
